import { Component } from '@angular/core';
import {EmpresaService} from "../../../services/empresa.service";
import {ItemEmpresa, ListaEmpresa} from "../../../models/lista-empresa";
import {DatePipe} from "@angular/common";

@Component({
    selector: 'app-empresas',
    templateUrl: './empresas.component.html',
    styleUrl: './empresas.component.css',
    standalone: false
})
export class EmpresasComponent {
  loading = true;
  public colunas = [`Nome`, 'CNPJ/CPF', 'Responsável', 'Email', 'Data Cadastro', 'Status'];
  public linhas: any[] = [];
  listaEmpresa = new ListaEmpresa();

  constructor(private empresaService: EmpresaService,
              private datePipe: DatePipe) {
    this.buscarEmpresas();
  }

  private buscarEmpresas(){
    this.empresaService.listar().subscribe(retorno =>{
      if(retorno.sucesso)
      {
        this.listaEmpresa = retorno.dados;
        this.preencherLista(retorno.dados.itens);
      }
    });
    this.loading = false;
  }

  private preencherLista(listaItens: ItemEmpresa[]){
    for(let item of listaItens) {
      let stringArray: string[] = [];
      let status = '';
      let nome = '';
      let cnpjCPF = '';

      if(item.cnpj !== undefined
        && item.cnpj !== null){
        cnpjCPF = item.cnpj;
        nome = item.razaoSocial;
      }
      else if(item.cpf !== undefined
        && item.cpf !== null){
        cnpjCPF = item.cpf;
        nome = item.nome;
      }

      if(item.ativo)
        status = 'Ativo';
      else
        status = 'Desativado';

      stringArray.push(nome, cnpjCPF, item.responsavel, item.email, <string>this.datePipe.transform(item.dataCadastro, 'dd/MM/yyyy'), status);
      this.linhas.push(stringArray);
    }
  }
}
